export const selectUser = (state) => state.authSlice.auth.user;
